import { render, staticRenderFns } from "./DeleteProductPopup.vue?vue&type=template&id=00d166e6&scoped=true&"
import script from "./DeleteProductPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteProductPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteProductPopup.vue?vue&type=style&index=0&id=00d166e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d166e6",
  null
  
)

export default component.exports